import React from 'react';
import { FaBolt } from 'react-icons/fa';

/**
 * ByteUpgradeStrip
 * Free-tier CTA shown in place of the Byte panel when AI features are
 * disabled (`disableAiFeatures === true`). Mirrors the upgrade strip
 * from the supplied flashcode_study_no_byte.html reference.
 */
const ByteUpgradeStrip = ({
  message = 'Get AI-powered explanations and follow-up chat with Byte',
  ctaLabel = 'Upgrade',
  onUpgrade
}) => {
  return (
    <div className="byte-companion__upgrade-strip">
      <div className="byte-companion__upgrade-text">
        <FaBolt
          className="byte-companion__upgrade-icon"
          aria-hidden="true"
        />
        <span>{message}</span>
      </div>
      <button
        type="button"
        className="byte-companion__upgrade-btn"
        onClick={onUpgrade}
      >
        {ctaLabel}
      </button>
    </div>
  );
};

export default ByteUpgradeStrip;
